import React from "react";
import { TextField } from "@mui/material";

interface TextInputProps {
  field: string;
  formData: any;
  onChange: (field: string, value: string) => void;
  placeholder?: string;
  type?: string;
  label?: string;
  required?: boolean;
  endAdornment?: React.ReactNode;
  error?: string;
  multiline?: boolean;
  rows?: number;
}

const TextInput: React.FC<TextInputProps> = ({
  field,
  formData,
  onChange,
  placeholder,
  type = "text",
  label,
  required = false,
  endAdornment,
  error,
  multiline = false,
  rows,
}) => (
  <TextField
    fullWidth
    size="small"
    type={type}
    variant="outlined"
    label={label}
    required={required}
    value={formData[field]}
    placeholder={placeholder}
    onChange={(e) => onChange(field, e.target.value)}
    error={!!error}
    helperText={error}
    autoComplete={type === "password" ? "new-password" : "off"}
    multiline={multiline}
    rows={rows}
    InputProps={{
      endAdornment: endAdornment,
    }}
    sx={{
      "& .MuiFormLabel-asterisk": {
        color: "red",
      },
    }}
  />
);

export default TextInput;
